const en = {
  common: {
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    close: "Close",
    discardChanges: "Discard changes",
    saveChanges: "Save changes",
    add: "ADD",
    create: "Create",
    import: "Import",
    email: "Email",
    firstName: "First name",
    lastName: "Last name",
    name: "Name",
    address: "Address",
    postalCode: "Postal code",
    city: "City",
    country: "Country",
    vatNumber: "VAT number",
    identificationNumber: "Identification number",
    picture: "Picture",
    updateAvatar: "Update avatar",
    uploadNewPicture: "Upload a new profile picture",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    leaveBlankPassword: "Leave blank to keep the current password",
    switchLanguage: "Switch language",
    createOne: "Create one",
    createOrganization: "Create an organization",
    role: "Role",
    confirm: "Confirm",
    select: "Select",
    collapse: "Collapse",
    expand: "Expand",
    roleOwner: "Owner",
    roleAdmin: "Admin",
    roleMember: "Member",
    roleReader: "Reader",
    selectAClient: "Select a client",
    client: "Client",
    color: "Color",
    globalRoleSuperuser: "Superuser",
    globalRoleConfirmed: "Confirmed",
    globalRoleDisabled: "Disabled",
    globalRoleBan: "Banned",
    currency: "Currency",
    language: "Language",
    all: "All",
    selectedOne: "1 selected",
    selectedCount: "{{count}} selected",
    search: "Search...",
    noResults: "No results",
    clearFilter: "Clear",
    clearAllFilters: "Clear all filters",
    removeFilter: "Remove {{name}}",
    addFavorite: "Add to favorites",
    removeFavorite: "Remove from favorites",
    selectAll: "Select all",
    suggestions: "Suggestions",
    cropImageTitle: "Adjust your image",
    copy: "Copy",
    copied: "Copied to clipboard",
    copyId: "Copy ID",
  },
  cookieBanner: {
    title: "Cookie notice",
    message:
      "CWClock is an open-source product. The cookies and local storage it uses are required only for the app to function (sign-in, your theme and language) - never for tracking or analytics.",
    understand: "I understand",
  },
  days: {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
  },
  nav: {
    cwclock: "CWClock",
    cwclockHome: "CWClock home",
    switchOrganization: "Switch organization",
    createOrganization: "Create organization",
    gitRepository: "Git repository",
    documentation: "Documentation",
    contactForm: "Contact us",
    downloadAndroidApp: "Download the Android app",
    scanToDownloadAndroidApp: "Scan this QR code with your Android device to download the app.",
    editProfile: "Edit profile",
    editProfileTooltip: "Edit your profile and avatar",
    lightMode: "Light mode",
    darkMode: "Dark mode",
    switchToLightMode: "Switch to light mode",
    switchToDarkMode: "Switch to dark mode",
    logout: "Logout",
    login: "Login",
    goToLogin: "Go to the login page",
    collapseSidebar: "Collapse sidebar",
    expandSidebar: "Expand sidebar",
    timeTracker: "Time Tracker",
    calendar: "Calendar",
    reports: "Reports",
    organizations: "Organizations",
    clients: "Clients",
    projects: "Projects",
    users: "Users",
    organizationsAdmin: "Organizations",
    apiKeys: "API Keys",
    invoices: "Invoices",
    exportJobs: "Export Jobs",
  },
  auth: {
    doesNotHaveAccount: "Doesn't have an account?",
    signUp: "Sign Up",
    alreadyHaveAccount: "Already have an account?",
    logIn: "Log In",
    enterEmail: "Enter email",
    emailAddress: "Email address",
    password: "Password",
    logInToAccount: "Log in to your account",
    getStartedTitle: "Get started with CWClock",
    getStartedSubtitle: "Create an account to start tracking time and improve your productivity.",
    createAccount: "Create account",
    createAccountTitle: "Create your account",
    passwordsDontMatch: "Passwords doesn't match.",
    openSourceBy: "Open source solution by ",
    cwcloudLinkLabel: "CWCloud.tech",
    openSourceSuffix: ", sources are available",
    here: "here",
    documentationAvailable: ", documentation is available",
    orContinueWith: "Or continue with",
    continueWithGoogle: "Continue with Google",
    continueWithGithub: "Continue with GitHub",
    continueWithKeycloak: "Continue with Keycloak",
    forgotPassword: "Forgot your password?",
    forgotPasswordTitle: "Reset your password",
    forgotPasswordBody: "Enter your email address and we'll send you a link to reset your password.",
    sendResetLink: "Send reset link",
    backToLogin: "Back to log in",
    resetPasswordTitle: "Choose a new password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    resetPassword: "Reset password",
    missingResetToken: "This password reset link is invalid.",
    confirmationSuccess: "Your account has been confirmed. You can now log in.",
    confirmationInvalid: "This confirmation link is invalid or has expired.",
    confirmationBanned: "This account has been banned.",
    mfaChallengeTitle: "Two-factor authentication",
    mfaCodePlaceholder: "6-digit code",
    mfaVerify: "Verify",
    mfaUseSecurityKey: "Use a security key",
  },
  timeTracker: {
    whatAreYouWorkingOn: "What are you working on?",
    searchByCustomerOrProject: "Search by customer or project name",
    project: "Project",
    elapsedTime: "Elapsed time",
    stopTimer: "Stop the timer",
    startTimer: "Start the timer",
    stop: "Stop",
    start: "Start",
    currentTime: "Current time",
    emptyTitle: "Let's start tracking!",
    emptyBody: "Pick a project above and start the timer.",
    needOrganization: "You need an organization before you can track time.",
    taskDescription: "Description",
    day: "Day",
    allDay: "All day",
    markAllDay: "Mark as an all-day entry",
    half: "Half day",
    markHalf: "Mark as a half-day entry",
    billable: "Billable",
    nonBillable: "Non-billable",
    markBillable: "Count this time as billable",
    startTime: "Start time",
    endTime: "End time",
    reassignToMember: "Reassign to a member",
    searchMember: "Search member...",
    deleteRecordTitle: "Delete time record",
    deleteRecordBody: 'Are you sure to delete "{{text}}"? This can\'t be undone.',
    running: "Running",
    continueEntry: "Continue this entry",
    discardRunning: "Discard the running timer",
    discardRunningTitle: "Discard running timer",
    discardRunningBody: "Are you sure? The time tracked so far won't be recorded.",
    importCsv: "Import CSV",
    importCsvTitle: "Import time entries from CSV",
    importCsvHint:
      "Upload a detailed report CSV (from Clockify, or exported from another cwclock organization). Clients, projects and users are created automatically if missing; entries that already exist are skipped.",
    importCsvFile: "CSV file",
    importResult: "Import complete: {{created}} entries created, {{skipped}} skipped.",
    duration: "Duration",
    durationHint: "Hours and minutes, e.g. 0130 for 1:30, 0045 for 45 minutes",
    add: "Add",
    addEntry: "Add this time entry",
    logMode: "How to log time",
    modeTimer: "Timer",
    modeManual: "Manual",
    setStart: "Set start time",
    endNow: "Remove the start time (the entry ends now)",
    startDate: "Start date",
  },
  calendar: {
    today: "Today",
    previousMonth: "Previous month",
    nextMonth: "Next month",
    monthView: "Month",
    weekView: "Week",
    addTimeRecord: "Add a time record",
    editTimeRecord: "Edit time record",
    start: "Start",
    end: "End",
    endSameDayHint: "End must be on the same day as start - multi-day entries aren't supported yet.",
    fillRequiredFields: "Please fill in the description, project and date fields.",
    moreEntries: "+{{count}} more",
    allDayRowLabel: "All day",
    shareTitle: "Share calendar",
    shareIntro: "Subscribe to your time entries from Outlook or Google Calendar using this personal feed link.",
    shareEnable: "Enable calendar sharing",
    shareRegenerate: "Generate a new link",
    shareHint:
      'Anyone with this link can see your time entries. In Google Calendar: Settings > Add calendar > "From URL". In Outlook: Add calendar > "Subscribe from web".',
  },
  profile: {
    editProfileTitle: "Edit profile",
    pleaseAddNames: "Please add both first and last name.",
    passwordsDoNotMatch: "Passwords do not match.",
    passwordsMatch: "Passwords match.",
    couldNotUpdate: "Could not update your profile. Please try again.",
    saveProfile: "Save your profile",
    mfaTitle: "Two-factor authentication",
    mfaTotp: "Authenticator app",
    mfaWebAuthn: "Security keys",
    mfaEnable: "Enable",
    mfaDisable: "Disable",
    mfaConfirm: "Confirm",
    mfaSecretHint: "Or enter this code manually: {{secret}}",
    mfaRegisterKey: "Register a security key",
    mfaSecurityKeyNamePrompt: "Name this security key",
    mfaSecurityKeyNameLabel: "Device name",
    mfaSecurityKeyDefaultName: "Security key",
    mfaDisableTitle: "Disable two-factor authentication",
    mfaDisableBody: "Disable the authenticator app for your account?",
    mfaDeleteKeyTitle: "Remove security key",
    mfaDeleteKeyBody: 'Remove the security key "{{name}}"? This cannot be undone.',
  },
  disabled: {
    adminMode: {
      title: "Account disabled",
      body: "Your account is disabled. Please contact an administrator to get access.",
    },
    emailMode: {
      title: "Confirm your account",
      body: "Please check your email and click the confirmation link to activate your account.",
    },
    signOut: "Sign out",
  },
  banned: {
    title: "Account banned",
    body: "Your account has been banned by an administrator.",
    signOut: "Sign out",
  },
  organizations: {
    title: "Organizations",
    switchTo: "Switch to {{name}}",
    createOrganization: "Create an organization",
    editOrgTitle: "Edit {{name}}",
    editOrganization: "Edit organization",
    accountingEmail: "Accounting email",
    accountingEmailPlaceholder: "Optional - cc'd on every invoice email",
    iban: "IBAN",
    bic: "BIC",
    editOrgTooltip: "Edit this organization's details",
    membersOf: "Members of {{name}}",
    addMemberPanel: "Add a member",
    memberEmail: "Member email",
    inviteMember: "Invite this member",
    addMemberButton: "Add member",
    couldNotAddMember: "Could not add member. Check the email and try again.",
    transferOwnership: "Transfer ownership",
    newOwnerEmail: "New owner's email",
    transferOwnershipTooltip: "Transfer ownership to this member",
    confirmTransfer: 'Transfer ownership of "{{name}}" to {{email}}? This cannot be undone.',
    couldNotTransfer: "Could not transfer ownership. Check the email and try again.",
    nameRequired: "Name is required.",
    noDailyRateSet: "No daily rate set",
    dailyRatePerDay: "{{rate}} {{currency}}/day",
    editDailyRate: "Edit daily rate",
    dailyRate: "Daily rate",
    currency: "Currency",
    saveDailyRate: "Save daily rate",
    selectOrCreateFirst: "Select or create an organization first",
    stamp: "Stamp",
    naf: "NAF Code",
    emptyTitle: "No organizations yet",
    emptyBody: "Create your first organization below to get started.",
    externalConnections: "External connections",
    addConnection: "Add a connection",
    connectionType: "Connection type",
    s3: "S3",
    googleDrive: "Google Drive",
    git: "Git",
    endpoint: "Endpoint",
    bucketName: "Bucket name",
    region: "Region",
    accessKey: "Access key",
    secretKey: "Secret key",
    serviceAccount: "Service account (JSON)",
    serviceAccountReadError: "Could not read this file.",
    folderId: "Folder ID",
    repoUrl: "Repository URL",
    subfolderPath: "Subfolder (optional)",
    subfolderPathPlaceholder: "e.g. invoices/cwclock",
    subfolderPathHint: "Subfolder files are written under - within the repo for git, the bucket for S3, or the folder for Google Drive. Leave blank to use its root.",
    gitAuthMethod: "Authentication method",
    gitAuthMethodPassword: "Username / password",
    gitAuthMethodSshKey: "SSH key",
    gitUsername: "Username",
    gitPassword: "Password",
    sshPrivateKey: "SSH private key",
    sshPrivateKeyPassphrase: "SSH private key passphrase (optional)",
    flatDirectory: "Flat directory (no subfolders)",
    flatDirectoryHint: "Upload files directly at the root instead of nesting them under YYYY/MM folders - useful for accounting software that requires a flat listing.",
    flatDirectoryBadge: "flat",
    deleteConnectionTitle: "Delete connection",
    deleteConnectionBody: 'Delete the connection "{{name}}"? This cannot be undone.',
    revokeMember: "Revoke this member",
    revokeMemberTitle: "Revoke member",
    revokeMemberBody: 'Revoke {{name}} from this organization? This cannot be undone.',
  },
  clients: {
    title: "Clients",
    createClient: "Create a client",
    vatRateLabel: "VAT rate % (default 20%)",
    vatDischargeMotive: "VAT discharge motive",
    contactName: "Contact's name",
    purchaseOrder: "Purchase order",
    hoursPerDay: "Hours/day (default 7)",
    dailyRate: "Daily rate (overrides member rate)",
    sendReportsWithInvoice: "Also send the summary and detailed reports with invoice emails",
    dailyRateSet: " - Daily rate {{rate}}",
    vatAndHours: " - VAT {{rate}}% - {{hours}}h/day",
    editClientTitle: "Edit {{name}}",
    emptyTitle: "No clients yet",
    emptyBody: "Create your first client above to get started.",
    deleteClientTitle: "Delete client",
    deleteClientBody: 'Delete "{{name}}"? This cannot be undone.',
    transferHint: "Moves this client, its projects and its logged time to an organization you own.",
    transferTargetOrg: "Target organization",
    transferButton: "Transfer",
    transferConfirmTitle: "Transfer client",
    transferConfirmBody: 'Transfer "{{name}}" to "{{orgName}}"? This cannot be undone.',
    noOtherOwnedOrgs: "You don't own any other organization to transfer this client to.",
    invoiceEmails: "Invoice's emails",
    invoiceEmailsHint: "Comma or semicolon separated list of recipients. Falls back to the client's email when empty.",
  },
  projects: {
    title: "Projects",
    createProject: "Create a project",
    needClient: "You need a client before you can create a project.",
    dailyRate: "Daily rate (overrides client rate)",
    dailyRateSet: "Daily rate {{rate}}",
    editProjectTitle: "Edit {{name}}",
    emptyTitle: "No projects yet",
    emptyBody: "Create your first project above to get started.",
    subdivisions: "Subdivisions",
    subdivisionsPlaceholder: "Add a subdivision",
    deleteProjectTitle: "Delete project",
    deleteProjectBody: 'Delete "{{name}}"? This cannot be undone.',
    transferHint: "Moves this project to a different client within this organization.",
    transferTargetClient: "Target client",
    transferButton: "Transfer",
    transferConfirmBody: 'Transfer "{{name}}" to "{{clientName}}"? This cannot be undone.',
    noOtherClients: "There's no other client in this organization to transfer this project to.",
    archive: "Archive",
    unarchive: "Unarchive",
    archived: "Archived",
    archivedSuffix: "(archived)",
    showArchived: "Show archived",
  },
  admin: {
    usersTitle: "Users",
    showFilterUsers: "Show {{filter}} users",
    filterAll: "all",
    deleteUserTitle: "Delete user",
    deleteUserBody: 'Delete "{{email}}"? This cannot be undone.',
    editUserTitle: "Edit {{email}}",
    pleaseValidUserFields: "Please add a valid email, first and last name.",
    emailInUse: "This email is already in use.",
    couldNotUpdateUser: "Could not update this user. Please try again.",
    globalRole: "Global role",
    saveUser: "Save this user",
    organizationsTitle: "Organizations",
    deleteOrgTitle: "Delete organization",
    deleteOrgBody: 'Delete "{{name}}"? This cannot be undone.',
    editOrgTitle: "Edit {{name}}",
    transferModalTitle: "Transfer ownership of {{name}}",
    transfer: "Transfer",
    disableMfa: "Disable MFA",
    disableMfaTitle: "Disable two-factor authentication",
    disableMfaBody: 'Disable two-factor authentication for "{{email}}"? This cannot be undone.',
  },
  apiKeys: {
    title: "API Keys",
    intro: "Create an API key to authenticate scripts and other tools using the X-Api-Key header, instead of logging in.",
    createKey: "Create an API key",
    description: "Description",
    expiresAt: "Expiration date (optional)",
    expiresOn: "Expires on {{date}}",
    neverExpires: "Never expires",
    emptyTitle: "No API keys yet",
    emptyBody: "Create your first API key above to get started.",
    createdTitle: "API key created",
    createdWarning: "Copy this key now - for your security, it won't be shown again.",
    downloadConfig: "Download CLI config",
    showQr: "Show QR code",
    hideQr: "Hide QR code",
    deleteKeyTitle: "Revoke API key",
    deleteKeyBody: 'Revoke "{{description}}"? Any script using it will stop working immediately.',
    openSwagger: "API documentation",
  },
  toasts: {
    orgCreated: "Organization created.",
    orgUpdated: "Organization updated.",
    orgDeleted: "Organization deleted.",
    memberAdded: "Member added.",
    dailyRateUpdated: "Daily rate updated.",
    ownershipTransferred: "Ownership transferred.",
    projectCreated: "Project created.",
    clientCreated: "Client created.",
    projectUpdated: "Project updated.",
    clientUpdated: "Client updated.",
    clientDeleted: "Client deleted.",
    clientTransferred: "Client transferred.",
    projectDeleted: "Project deleted.",
    projectArchived: "Project archived.",
    projectUnarchived: "Project unarchived.",
    userUpdated: "User updated.",
    userDeleted: "User deleted.",
    mfaDisabled: "Two-factor authentication disabled for this user.",
    timeRecordDeleted: "Time record deleted.",
    timeRecordUpdated: "Time record updated.",
    timeRecordCreated: "Time record created.",
    apiKeyDeleted: "API key revoked.",
    invoiceGenerated: "Invoice generated.",
    invoiceUpdated: "Invoice updated.",
    invoiceDeleted: "Invoice deleted.",
    invoiceReuploaded: "Invoice reuploaded to external connections.",
    externalConnectionAdded: "Connection added.",
    externalConnectionRemoved: "Connection removed.",
    memberRemoved: "Member removed.",
    profilePictureUpdated: "Profile picture updated.",
    profileUpdated: "Profile updated successfully.",
    accountCreated: "Account created successfully.",
    loggedIn: "Logged in successfully.",
    passwordResetSent: "If this email is registered, a reset link has been sent.",
    passwordReset: "Password updated. You can now log in.",
    invoiceSent: "Invoice sent.",
    contactSent: "Your message has been sent.",
  },
  contact: {
    title: "Contact us",
    body: "Have a question or feedback? Send us a message.",
    subject: "Subject",
    message: "Message",
    send: "Send message",
    backToTimeTracking: "Back to time reporting",
  },
  errors: {
    network: "Something went wrong. Please try again.",
    internal: "Something went wrong. Please try again.",
    notFound: "Resource not found.",
    duplicateEmail: "Email already in use.",
    userNotFound: "User not found.",
    invalidCredentials: "Invalid credentials.",
    nameRequired: "Please fill in the Name field.",
    countryRequired: "Please select a country.",
    allFieldsRequired: "Please add all fields.",
    invalidUserData: "Invalid user data.",
    invalidRequestBody: "Invalid request body.",
    invalidMemberInvite: "Please add a valid email and role (admin, member or reader).",
    noUserWithEmail: "No user with this email.",
    invalidRole: "Please add a valid role (admin, member or reader).",
    invalidDailyRate: "Please add a valid daily rate.",
    invalidEmail: "Please add a valid email.",
    invalidCurrency: "Please use a supported currency code.",
    cantDeleteOwnAccount: "You can't delete your own account.",
    invalidAdminUserEdit: "Please add valid email, name, surname and role fields.",
    timeEntryFields: "Please add text, client, project and day fields.",
    timeEntryStartEnd: "Please add start and end fields, or check all day.",
    timeEntryAllDayHalf: "Please check either all day or half day, not both.",
    ownTimeEntriesOnly: "You can only manage your own time entries.",
    noRunningEntry: "No timer is running.",
    timerAlreadyRunning: "A timer is already running.",
    runningEntryImmutable: "A running time entry can't be edited, stop the timer first.",
    invalidProjectForOrg: "That project does not belong to this organization.",
    invalidTimezone: "Unknown timezone.",
    reassignForbidden: "Only an admin or the owner can reassign a time entry to another member.",
    nameAndSurnameRequired: "Please add name and surname fields.",
    passwordsMismatch: "Passwords do not match.",
    apiKeyDescription: "Please add a description.",
    invalidExpiration: "Please add a valid expiration date.",
    imageTooLarge: "This image is too large.",
    invalidInvoiceStatus: "Please pick a valid invoice status.",
    invalidInvoiceRequest: "Please pick a client and a date range.",
    exportLimitExceeded: "This period has too many entries to export. Please narrow your filters or date range.",
    invalidDateRange: "The end date must be on or after the start date.",
    cantRemoveOwner: "The organization owner cannot be removed.",
    mustOwnTargetOrg: "You must own the target organization to transfer a client to it.",
    invalidClientForOrg: "That client does not belong to this organization.",
    projectArchived: "That project is archived. Unarchive it first to log time against it.",
    invalidCountry: "Please select a supported country.",
    invalidExternalConnection: "Please fill in every field for this connection type.",
    duplicateExternalConnection: "This external connection already exists.",
    oidcFailed: "Sign-in with this provider failed. Please try again.",
    accountDisabledAdmin: "Your account is disabled. Please contact an administrator to get access.",
    accountDisabledEmail: "Please check your email and click the confirmation link to activate your account.",
    accountBanned: "Your account has been banned by an administrator.",
    invoiceNumberExists: "An invoice with this number already exists.",
    invalidToken: "This link is invalid or has expired.",
    noInvoiceRecipient: "This client has no email address to send the invoice to.",
    mailLimitExceeded: "This organization has reached its monthly email limit. Please try again once it resets.",
    passwordTooShort: "Password must be at least 8 characters long.",
    passwordNoUpper: "Password must contain an uppercase letter.",
    passwordNoLower: "Password must contain a lowercase letter.",
    passwordNoSymbol: "Password must contain a special character.",
    contactFormNotConfigured: "The contact form isn't available right now.",
    contactFormFailed: "Failed to send your message, please try again later.",
    contactRateLimited: "You're sending too many messages. Please wait a bit before trying again.",
    contactMessageTooShort: "Your message is too short. Please add a bit more detail.",
    contactGibberish: "Your message looks like spam. Please rewrite it.",
    configTokenRequired: "Missing API key token.",
  },
  reports: {
    summary: "Summary",
    detailed: "Detailed",
    export: "Export",
    exportCsv: "Export as CSV",
    exportPdf: "Export as PDF",
    total: "Total",
    billable: "Billable",
    days: "Days",
    amount: "Amount",
    duration: "Duration",
    time: "Time",
    noEntries: "No time entries for this period.",
    noAccess: "You don't have access to reports in this organization.",
    chartHint: "Hours tracked per day for the selected period.",
    donutHint: "Hours tracked per project for the selected period.",
    dateRangeShortcuts: "Date range shortcuts",
    shortcuts: "Shortcuts",
    startDate: "Start date",
    endDate: "End date",
    shortcutToday: "Today",
    shortcutYesterday: "Yesterday",
    shortcutThisWeek: "This week",
    shortcutLastWeek: "Last week",
    shortcutPastTwoWeeks: "Past two weeks",
    shortcutThisMonth: "This month",
    shortcutLastMonth: "Last month",
    shortcutPastTwoMonths: "Past two months",
    shortcutThisYear: "This year",
    shortcutLastYear: "Last year",
    includeFormerMembers: "Include former members",
    formerMember: "{{name}} (former)",
    sourceManual: "Manual",
    sourceManualTooltip: "Entered manually",
    sourceImport: "Imported",
    sourceImportTooltip: "Imported from a CSV file",
  },
  invoices: {
    title: "Invoices",
    selectAClient: "Select a client",
    clientRequired: "Please pick a client and a date range.",
    preview: "Preview",
    generate: "Generate",
    previewHint: "Preview only renders the PDF - nothing is saved.",
    generateHint: "Generate saves the invoice and downloads its PDF.",
    listTitle: "Invoices for this period",
    emptyTitle: "No invoices yet",
    emptyBody: "Preview or generate one above to get started.",
    number: "Number",
    period: "Period",
    status: "Status",
    total: "Total TTC",
    download: "Download PDF",
    reupload: "Reupload to external connections",
    editStatus: "Edit status",
    saveStatus: "Save status",
    statusUnpaid: "Unpaid",
    statusPaid: "Paid",
    statusCanceled: "Canceled",
    statusRefunded: "Refunded",
    noAccess: "You don't have access to invoices in this organization.",
    deleteInvoiceTitle: "Delete invoice",
    deleteInvoiceBody: 'Delete invoice "{{number}}"? This cannot be undone.',
    generateWithId: "Generate with id",
    generateWithIdHint: "Generate an invoice using a specific id instead of the usual computed one.",
    generateWithIdTitle: "Generate invoice with id",
    invoiceIdLabel: "Invoice id",
    invoiceIdPlaceholder: "e.g. CLIENT202601011",
    invoiceIdRequired: "Please enter an invoice id.",
    sendInvoice: "Send invoice by email",
  },
  exportJobs: {
    title: "Export Jobs",
    create: "Create Export Job",
    newJob: "New Export Job",
    editJob: "Edit Export Job",
    emptyTitle: "No export jobs yet",
    emptyBody: "Create one above to schedule automated report exports.",
    enabled: "Enabled",
    disabled: "Disabled",
    enable: "Enable this job",
    disable: "Disable this job",
    runNow: "Run now",
    runNowSuccess: "Export job started",
    nextRunTooltip: "Next execution time",
    nextRunNow: "now",
    needOrganization: "Please select an organization to manage export jobs.",
    needAdminAccess: "Only admins can manage export jobs.",
    cronExpression: "Cron Expression",
    cronExpressionRequired: "Please enter a cron expression.",
    timePeriod: "Time Period",
    timePeriodRequired: "Please select a time period.",
    reportTypes: "Report Types",
    selectReportTypes: "Select report types to export",
    clients: "Clients",
    allClientsSelected: "All clients will be included",
    projects: "Projects",
    allProjectsSelected: "All projects will be included",
    includeFinancialData: "Include financial data in reports",
    targetsLabel: "Targets",
    selectTargets: "Please add at least one target.",
    toEmails: "To (comma or semicolon separated)",
    ccEmails: "CC (comma or semicolon separated)",
    targetTypeEmail: "Email",
    targetType: "Target type",
    addTarget: "Add target",
    removeTarget: "Remove target",
    jobNamePlaceholder: "e.g., Daily Summary Report",
    createdSuccessfully: "Export job created successfully",
    updatedSuccessfully: "Export job updated successfully",
    deletedSuccessfully: "Export job deleted successfully",
    deleteConfirmTitle: "Delete export job",
    deleteConfirmMessage: 'Delete export job "{{name}}"? This cannot be undone.',
  },
};

export default en;
